import { createUseStyles } from 'react-jss';
import { color, fontWeight } from '@blink/components';

export const useVaultActivationInProgressStyle = createUseStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        textAlign: 'center',
        width: 512,
    },
    header: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    title: {
        fontSize: 20,
        fontWeight: fontWeight.bold,
        color: color.content.primary,
        margin: '24px 0 8px 0',
    },
    subtitle: {
        fontSize: 16,
        color: color.content.secondary,
        margin: '0 12px',
    },
    vaultActivationInProgressModalWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
});
